var _circle, _path, _path2, _path3, _line, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoalMix(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 15.9995,
    r: 2.13333,
    fill: "#D91F05"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31 16C31 24.2843 24.2843 31 16 31C7.71573 31 1 24.2843 1 16C1 7.71573 7.71573 1 16 1C16.336 1 16.6695 1.01105 17 1.0328V0.030742C16.6693 0.0103478 16.3358 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32C24.8366 32 32 24.8366 32 16H31Z",
    fill: "#D91F05"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 5.37925C16.6708 5.34865 16.3373 5.33301 16.0002 5.33301C10.1091 5.33301 5.3335 10.1086 5.3335 15.9997C5.3335 21.8907 10.1091 26.6663 16.0002 26.6663C21.8911 26.6663 26.6667 21.8909 26.6668 16H25.6668C25.6667 21.3386 21.3388 25.6663 16.0002 25.6663C10.6614 25.6663 6.3335 21.3384 6.3335 15.9997C6.3335 10.6609 10.6614 6.33301 16.0002 6.33301C16.3378 6.33301 16.6713 6.35031 17 6.38409V5.37925Z",
    fill: "#D91F05"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 9.67726C16.6742 9.62615 16.3402 9.59961 16.0001 9.59961C12.4655 9.59961 9.6001 12.465 9.6001 15.9996C9.6001 19.5342 12.4655 22.3996 16.0001 22.3996C19.5346 22.3996 22.3999 19.5344 22.4001 16H21.4001C21.3999 18.9822 18.9823 21.3996 16.0001 21.3996C13.0178 21.3996 10.6001 18.9819 10.6001 15.9996C10.6001 13.0173 13.0178 10.5996 16.0001 10.5996C16.3417 10.5996 16.676 10.6313 17 10.692V9.67726Z",
    fill: "#D91F05"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 15.4592,
    y1: 16.4915,
    x2: 26.5275,
    y2: 6.24215,
    stroke: "#D91F05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6 4.26641V6.93307H28.2666L31.4666 4.26641H28.2666V1.06641L25.6 4.26641Z",
    fill: "#D91F05"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoalMix);
export default __webpack_public_path__ + "static/media/goal_mix.60e977d790184e5c6c575292bbd7815e.svg";
export { ForwardRef as ReactComponent };